import PlayerBase from '../player_base';
import Logger from '../../utils/logger';

export default class ChromeCastPlayer extends PlayerBase {
  _chromecastSenderService = null;

  constructor(parent) {
    super(parent);
    this._chromecastSenderService = parent._chromecastSenderService;
  }

  unload() { // eslint-disable-line class-methods-use-this
    // nothing to do here
  }

  destroy() { // eslint-disable-line class-methods-use-this
    // nothing to do here
  }

  async load() { // eslint-disable-line class-methods-use-this
    // nothing to do here
    // CC try to load content after preroll
  }

  fastForward(jump = 15) {
    return this.seek(this.parent.model.currentTime + jump);
  }

  rewind(jump = 15) {
    return this.seek(this.parent.model.currentTime - jump);
  }

  async seek(time) {
    try {
      this.parent.model = this.parent.model.merge({ isSeeking: true });

      await this._chromecastSenderService.seek(time);
      Logger.debug(`ChromeCastPlayer.seek(${time}) done`);

      const timeSeek = Number(time);
      this.parent.playerElement.currentTime = timeSeek;
      Logger.debug('Seeking to', timeSeek);
    } catch (err) {
      Logger.warn(`ChromeCastPlayer.seek(${time}) failed`, err);
    }

    this.parent.model = this.parent.model.merge({ isSeeking: false });
  }

  play() {
    this._chromecastSenderService.play();
  }

  pause() {
    this._chromecastSenderService.pause();
  }

  togglePlay() {
    if (this.parent.model.isPlaying) {
      this.pause();
    } else {
      this.play();
    }
  }

  async changeVolume(volume) {
    try {
      this.parent._saveVolume(volume);
      await this._chromecastSenderService.setReceiverVolume(volume);
      Logger.debug(`ChromeCastPlayer changeVolume ${volume} success`);
    } catch (err) {
      Logger.warn(`ChromeCastPlayer changeVolume ${volume} error`, err);
    }
  }

  async toggleMute() {
    if (this.parent.model.volume === 0) {
      await this.changeVolume(this.parent._getActiveVideoVolume());
    } else {
      await this.changeVolume(0);
    }
  }

  changeAudioPreference(audioPreference) {
    this._chromecastSenderService.changeTextTrackOrAudio(audioPreference, 'AUDIO');
  }

  changeTextTrackPreference(textTrackPreference) {
    this._chromecastSenderService.changeTextTrackOrAudio(textTrackPreference, 'TEXT');
  }

  changeBitratePreference() {
    // NYI
  }

  skip() {
    this._chromecastSenderService.skip();
  }

  openAdWebsite() {
    this._chromecastSenderService.openAdWebsite();
  }
}
